import React from 'react';
import SvgIcon from './SvgIcon';
function DocumentSearch(_a) {
    var className = _a.className;
    return (React.createElement(SvgIcon, { className: className },
        React.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", "aria-hidden": "true" },
            React.createElement("rect", { x: "3.25", y: "2.25", width: "8.5", height: "11.5", rx: "1.75", stroke: "currentColor" }),
            React.createElement("path", { d: "M6 5.5h3M6 8h3M6 10.5h1.5", stroke: "currentColor", strokeLinecap: "round" }),
            React.createElement("path", { d: "m11.75 11.75 1.15 1.15m-.35-2.05a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" }))));
}
export default DocumentSearch;
